export function getCachePriceRows(pricing) {
  if (!pricing) {
    return [];
  }

  const rows = [];

  if (pricing.cache_creation_price) {
    rows.push({
      key: 'cache_creation_price',
      label: '缓存写入',
      detailLabel: '缓存写入 Token',
      price: pricing.cache_creation_price,
    });
  }

  if (pricing.cache_read_price) {
    rows.push({
      key: 'cache_read_price',
      label: '缓存读取',
      detailLabel: '缓存读取 Token',
      price: pricing.cache_read_price,
    });
  }

  return rows;
}
